import React, { createContext, useState, useMemo, useContext } from "react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { accessibleTheme, normalTheme } from "./accessibleTheme"; // Путь к вашим темам

// 1. Создаем контекст
const ThemeToggleContext = createContext({
  toggleTheme: () => {},
});

// 2. Хук для легкого доступа к функции переключения
export const useThemeToggle = () => useContext(ThemeToggleContext);

// 3. Создаем Провайдер, который будет хранить состояние
export const CustomThemeProvider = ({ children }) => {
  const [themeMode, setThemeMode] = useState("normal"); // 'normal' или 'accessible'

  const toggleTheme = () => {
    setThemeMode(prevMode => (prevMode === "normal" ? "accessible" : "normal"));
  };

  // Выбираем тему в зависимости от состояния
  // useMemo нужен, чтобы React не пересоздавал объект темы при каждом рендере
  const theme = useMemo(
    () => (themeMode === "normal" ? normalTheme : accessibleTheme),
    [themeMode],
  );

  return (
    <ThemeToggleContext.Provider value={{ toggleTheme }}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />{" "}
        {/* Обязательно для сброса стилей и применения фона темы */}
        {children}
      </MuiThemeProvider>
    </ThemeToggleContext.Provider>
  );
};
